import React from 'react'
import styled from 'styled-components'
import Navbar from '../components/Navbar'

const SupportPage = () => {
    return (
        <div>
            <Navbar />
            <ContentBox>
                SupportPage
            </ContentBox>
        </div>
    )
}

export default SupportPage

const ContentBox = styled.div`
  width: 98%;
  margin-top: 70px;
  z-index: -10000000;


`
